import { Icon, forwardRef } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

const CopyIcon = forwardRef((props, ref) => {
    const { darkMode } = useSelector((state) => state.settings);

    return (
        <Icon
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke={darkMode ? 'white' : 'black'}
            className="h-5 w-5"
            {...props}
            ref={ref}>
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
            />
        </Icon>
    );
});

export { CopyIcon };
